<template>
  <section class="flex level-1"  :class="{mobile:!mobile}">    
        <!-- //TITLE MOBILE -->
          <div class="mobile"  :class="{isMobile:isMobile}"   v-if="mobile">

            <div class="link">
              <button class="bt btn-back" @click="goBack()">
                <font-awesome-icon :icon="['far', 'angle-left']"/>
              </button>
              <h2>{{general.messagerieTitle}}</h2>
            </div>
            <div class="sep"></div>
          </div>
        <!-- //TITLE MOBILE -->


        <!-- CONTENT -->

        <div class="block__messagerie content__messagerie">

          <b-overlay
            id="overlay-challenge"
            :show="show"
            rounded="sm"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-small
            style="position:initial!important"          
          >   
            <!-- PART MIDDLE -->
            <div class="column-middle">

              <!-- //TITLE DESKTOP -->
                <div class="desktop">
                  <h1>{{general.messagerieTitle}}</h1>
                </div>
              <!-- //TITLE DESKTOP -->       
              
              <Stack></Stack>

              <!-- TITLE -->
              <h2>{{general.messagerieSubTitle}}</h2>
              <!-- TITLE -->
              <Stack></Stack>
              

              <!-- CARD CONTENEUR CENTRAL  -->
              <b-card>
                <!-- HEADER -->
                <header>
                  <div class="flex">
                    <h2>{{general.messagerieSentTo}}</h2>
                    <button class="btn-add" @click="parentActive" v-if="isMobile">{{general.messagerieAdd}}</button>
                  </div>
        
                  <Stack></Stack>

                  <!-- LIST SELECTED RECEIVER $EMIT -->
                  <div class="flex selected">
                      <ul v-if='lists.length'>
                        <li v-for="(select,id) in lists" :key="id" style="display:inline;">
                          {{select.fullName}}
                        </li>
                      </ul>
                    <h3 v-else>{{general.messagerieNobody}}</h3>
                  </div>
                  <!-- LIST SELECTED RECEIVER $EMIT -->

                </header>
                <!-- HEADER -->

                <Stack></Stack>

                <!-- CONTENT -->
                <div> 
                    <!-- OBJECT -->
                    <b-form-group
                      id="input-group-messagerie-title"
                      label="Objet"
                      label-for="messagerie-title"
                    >
                      <b-form-input
                        id="messagerie-title"
                        required
                        :placeholder="general.messageriePlaceholderObject"
                        v-model="subject"
                      ></b-form-input>
                    </b-form-group>   
                    <!-- OBJECT -->

                    <!-- TEXTAREA IF MOBILE -->
                    <div v-if="isMobile">
                      <b-form-group
                        id="input-group-messagerie-message"
                        label="Votre message"
                        label-for="messagerie-title"
                      >
                        <b-form-textarea
                          id="messagerie-message"
                          rows="8"
                          required
                          placeholder="Votre message"
                          v-model="message"
                        ></b-form-textarea>
                      </b-form-group> 
                    </div>   
                    <!-- TEXTAREA IF MOBILE -->

                    <!-- EDITOR TINYMCE IF NOT MOBILE -->
                    <Editor
                      apiKey="ft66pqql8qct8gk5w9wvhdxzi1x22n5y61r9nqntppyec9uk"
                      v-model="tinycontent"
                      initial-value=""
                      :init="{
                        height: 500,
                        menubar: false,
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount'
                        ],
                        toolbar:
                          'undo redo | formatselect | bold italic backcolor | \
                          alignleft aligncenter alignright alignjustify | \
                          bullist numlist outdent indent | removeformat | help',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                      }"
                      v-if="!isMobile"
                    />
                    <!-- EDITOR TINYMCE IF NOT MOBILE -->
  

                    <!-- ALERTS -->
                    <Stack height="1rem" class="desktop" v-if="infoMessage != null"></Stack>
                    <b-alert variant="danger" :show="error">{{infoMessage}}</b-alert>
                    <!-- <b-alert variant="success" :show="success">Success Alert</b-alert>
                    <b-alert variant="danger" :show="error">Error Alert</b-alert>
                    <b-alert variant="info" :show="info">Info Alert</b-alert> -->
                    <!-- ALERTS -->

                    <Stack height="1rem" class="desktop"></Stack>

                  <!-- BUTTONS -->
                    <div class="buttons-container">
                      <button class="btn btn-send" @click="send">{{general.messagerieSend}}</button>
                      <Stack height="1rem" class="mobile"></Stack>
                      <button ref="btn-show" class="btn btn-show" @click="preview">{{general.messageriePreview}}</button>
                      <Stack height="1rem" class="mobile"></Stack>
                      <button class="btn btn-grey" @click="cancel">{{general.messagerieCancel}}</button>
                    </div>
                  <!-- BUTTONS -->

                </div>
                <!-- CONTENT -->

              </b-card>
              <!-- CARD CONTENEUR CENTRAL  -->

            </div>
            <!-- PART MIDDLE -->
          </b-overlay>
          <!-- PART RIGHT -->
          <div class="col-right column-right borderLeft" v-if="!isMobile">
            <ChallengesMessagerieContact
              :noTitle='false'
              ref="listEmailComponent" 
              v-on:receiver="updatereceiver"
              v-on:validated="updatereceiver"
            ></ChallengesMessagerieContact>
          </div>
          <!-- PART RIGHT -->

        </div>
    <!-- CONTENT-->



    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
    <transition name="modal"> 
      <keep-alive>
        <router-view name="helper" class="myModal"></router-view>
      </keep-alive>
    </transition>    
    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->


  <EmailPreview :content="!isMobile?tinycontent:message" />
  <!-- <EmailPreview :content="!isMobile?tinycontent:message" :message="message"/> -->
  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import Stack from '../../../module/stack/Stack'
import ChallengesMessagerieContact from '../../../pages/sub_category/challenges/ChallengesMessagerieContact'
import Editor from '@tinymce/tinymce-vue'
import EmailPreview from '../../../../components/module/modal/EmailPreview';
import ApiService from '../../../../services/ApiService';
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService';

export default {
  name:"challengeMessagerie",
    components:{ 
      Stack,
      ChallengesMessagerieContact,
      Editor,
      EmailPreview
    }, 
    computed: {
      ...mapGetters([
        'getBlog',
         'getListeEmail',
         'getGeneral',
         'getChallengeSelected',
          'getIsMobile'
      ])
    },
    data () {
      return {
        general:'',
        lists:"",
        title:"",
        isLoading:true,
        isMobile:false,
        success:false,
        error:false,          
        info:false, 
        subject:'',
        message:'',
        tinycontent:'',
        selected:'', 
        infoMessage: '',
        show:false,       
      }
    },
    created (){
      this.lists = this.getListeEmail;
      this.isMobile = this.getIsMobile;
      this.general = this.getGeneral;
    },    
    props:{
      mobile:{
        type:Boolean,
        default:true
      }
    },    

    methods : {
      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challengesHome"});  
      },   

      swipeRightHandler () {
          this.goBack();
      },  

      async send(){
       if(this.lists.length > 0 && this.subject != ""){
         this.show = true;
          let contentDesc  = !this.isMobile ? this.tinycontent : this.message;
          let info = {
            recipients:this.lists.map(element=> element.email), 
            object:this.subject,
            message:contentDesc,
          }
          this.infoMessage = null;
          this.error = false;
          let response = await ApiService.getMessagingApi().send(ApiAuthenticationService.getCurrentUser().id,this.getChallengeSelected,info);
          response.status == '200' ?  this.messageSuccess() : this.messageError();
          this.show = false;

        } else if(this.lists.length === 0){
          this.infoMessage = this.general.messagerieErrorDest;
          this.error = true;
        } else if (this.subject == ""){
          this.infoMessage = this.general.messagerieErrorTitle;
          this.error = true;
        }
      },  
      messageSuccess(){
        this.makeToast('success')
        this.cancel();
      },  
      messageError(){
        this.makeToast('error')
        // this.cancel();
      },  
      //AFFICHAGE DU TOAST
      makeToast(variant = null) {
        if(variant == 'success'){
          this.$bvToast.toast(this.general.messagerieSuccess, {
            title: this.general.messagerieToastTitle,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          })  
        } else if(variant == 'error'){
          this.$bvToast.toast(this.general.messagerieError, {
            title: this.general.messagerieToastTitle,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          }) 
        } 
        // else if(variant == 'info'){
        //   this.$bvToast.toast('Le challenge a été mis à jour.', {
        //     title: `Enregistrement challenge`,
        //     variant: 'success',
        //     solid: true,
        //     toaster:'b-toaster-top-center'
        //   }) 
      },

      preview(){
        this.$bvModal.show('email-preview')	
      },        
      cancel(){
        this.tinycontent = '';
        this.subject = '';
        this.lists=[];
        this.$refs.listEmailComponent.cancel();
      },  

      updatereceiver(data){
        this.selected = data;
      },

      parentActive(){
        this.$emit('parentactive');
        this.$router.push({name: "challenges-messagerie-contact-mobile"}); 
        this.isMobile ? this.$store.dispatch('showFooter',false):'';
      }

    },
    watch: {
        getListeEmail() {
          this.lists = this.getListeEmail;
          this.infoMessage != null ? this.infoMessage = null : '';
          this.error = false;
        },
      getIsMobile(){
          this.isMobile = this.getIsMobile;
      }
    }, 
};
</script>
